import {propsDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import TouristGroupView from '@/js/common/components/touristGroupView/TouristGroupView';

import dropDownTemplate from './templates/dropDownTemplate.html';
import './styles/touristGroupView.scss';

@propsDecorator({
    template: dropDownTemplate,
})

export default class TouristGroupDesktop extends TouristGroupView {
    render() {
        this.$el.html(this.template({cid: this.cid}));
    }
}